import { getEncText } from "../../service/user";
import _ from "lodash";
import { mapState } from "vuex";
import { decode } from "../../libs/rsa";
import { onInputRange } from "@/utils/util.js";
export default {
  props: ["encText", "mode", "disabled", "params", "documentId"],
  data() {
    return {
      show: false,
      value: "",
      saveEncText: "",
      saveRevalText: ""
    };
  },
  methods: {
    input(val) {
      this.value = val;
      onInputRange(this, this, "value", this.documentId);
      this.$emit("input", val);
    },
    async showText() {
      if (!this.show) {
        const res = await getEncText({
          mode: this.mode,
          ...this.params
        });
        if (res && res.data) {
          this.show = true;
          this.value = decode(res.data.retVal);
          this.saveRevalText = _.cloneDeep(this.value);
          this.$emit("input", this.value);
        }
      } else {
        // console.log("回显", this.value, this.saveRevalText, this.saveEncText);
        if (_.isEqual(this.value, this.saveRevalText)) {
          this.show = false;
          this.value = this.saveEncText;
        } else {
          this.$Modal.confirm({
            title: $t("b49etw6", "是否取消修改"),
            onOk: () => {
              console.log("ok");
              this.show = false;
              this.$emit("input", this.saveRevalText);
              this.value = this.saveEncText;
            }
          });
        }
      }
    }
  },
  destroyed() {
    this.show = false;
  },
  mounted() {
    this.saveEncText = _.cloneDeep(this.encText);
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    showValue() {
      return this.show ? this.value : this.encText;
    },
    type() {
      return this.show ? "ios-eye-outline" : "ios-eye-off-outline";
    }
  }
};